import type { LucideIcon } from "lucide-preact";

export type TabItem = {
  id: string;
  label: string;
  icon: LucideIcon;
};

type TabBarProps = {
  items: TabItem[];
  activeId: string;
  onSelect: (id: string) => void;
};

/** Bottom tab bar under 900px, left rail at/above it — see .tabbar in components.css. */
export function TabBar({ items, activeId, onSelect }: TabBarProps) {
  return (
    <nav class="tabbar" aria-label="Primary">
      {items.map((item) => {
        const Icon = item.icon;
        const active = item.id === activeId;
        return (
          <button
            key={item.id}
            type="button"
            class={["tabbar-item", active && "tabbar-item-active"].filter(Boolean).join(" ")}
            aria-current={active ? "page" : undefined}
            onClick={() => onSelect(item.id)}
          >
            <Icon size={22} strokeWidth={1.75} />
            <span>{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
